<script setup>
import dayjs from 'dayjs'

const props = defineProps({
  categories: {
    type: Array,
    default: () => [],
  },
  article: {
    type: Object,
    default: () => {},
  },
  date: {
    type: String,
    default: '',
  },
  slug: {
    type: String,
    default: '',
  },
  custom: {
    type: Object,
    default: () => {},
  },
  activeIndex: {
    type: Number,
    default: null,
  },
  index: {
    type: Number,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
})

const router = useRouter()
function filteredRoute() {
  if (props.article.custom_link?.id !== '' && props.article.custom_link !== undefined) {
    const category = props.article.custom_link.cached_url ? props.article.custom_link.cached_url : props.article.custom_link.url
    const result = category.replace(/th\/+/, '')
    return `${result}`
  }
  else {
    const category = props.slug
    const result = category.replace(/th\/+/, '')
    return `${result}`
  }
}

const badge = ref([])

function filteredUUID() {
  if (props.article.categories?.length) {
    for (let i = 0; i <= props.article?.categories?.length; i++) {
      const data = props.article?.categories[i]
      for (let i = 0; i <= props.categories?.length; i++) {
        const data2 = props.categories[i]

        if (data === data2?.uuid && data2 !== undefined)
          badge.value.push({ id: data2?.uuid, value: data2?.name })
      }
    }
  }
}

onMounted(() => {
  filteredUUID()
})
</script>

<template>
  <nuxt-link
    :to="localePath({ path: `/${slug}` })"
    :class="activeIndex === index ? 'shadow-custom-lg/90 scale-[103%] antialiased backface-hidden perspective-[1px] translate-z-0' : 'scale-100'"
    class="group/card relative cursor-pointer border border-gray-200 rounded-lg rounded-lg bg-white text-left transition duration-200 ease-in-out"
  >
    <CardSkeletonCard v-if="loading" />
    <div v-else class="min-h-[350px] 4xl:min-h-[485px] 5xl:min-h-[535px]">
      <div v-if="article.image?.filename" class="w-full rounded-tl-lg rounded-tr-lg">
        <nuxt-img
          loading="lazy" sizes="sm:400px, md:600px" width="350" height="200" :src="article.image?.filename" :alt="article?.title"
          class="h-full max-h-[160px] min-h-[160px] w-full rounded-tl-lg rounded-tr-lg object-cover 4xl:max-h-[235px] 4xl:min-h-[235px] 5xl:max-h-[280px] 5xl:min-h-[280px]"
        />
      </div>
      <div class="min-h-[25px] flex flex-wrap translate-y-[-50%] items-center gap-1.5 px-4 md:px-6">
        <div v-for="item in badge" v-if="badge?.length" :key="item.id">
          <span class="rounded-full bg-blue-600 px-2.5 py-1 text-xs text-white font-semibold">{{ item.value }}</span>
        </div>
        <div v-else>
          <span class="rounded-full bg-blue-600 px-2.5 py-1 text-xs text-white font-semibold">Dexon</span>
        </div>
      </div>
      <div class="relative px-4 pb-5 md:px-6">
        <div>
          <div v-if="article.date" class="mb-1.5">
            <span class="text-sm text-slate-400 font-semibold uppercase">{{ dayjs(article.date).format('DD MMMM YYYY') }}</span>
          </div>
          <h2 v-if="article.title" class="line-clamp-2 mb-3 text-md font-bold leading-[1.4]">
            {{ article.title }}
          </h2>
          <p
            v-if="article.description"
            class="line-clamp-3 mb-custom-sm text-sm"
          >
            {{ article.description }}
          </p>
        </div>
        <div>
          <UIButton type="button" class="mt-4 flex items-center rounded-md" size="xs" ring="none" :theme="activeIndex === index ? 'fill' : 'text'">
            {{ $t('button.more') }}
          </UIButton>
        </div>
      </div>
    </div>
  </nuxt-link>
</template>

<style>
.skeleton-animate {
  animation: card-loading 2.5s ease-in infinite;
}

.highlight-animate {
  animation: highlight-loading 1.25s ease-in infinite;
  mix-blend-mode: lighten
}

@keyframes card-loading {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
    /* transform: 100%; */
  }

  100% {
    opacity: 1;
    /* transform: -50%; */
  }
}

@keyframes highlight-loading {
  0% {
    left: -50%;
    transform: skewX(20deg);
    opacity: 0;
  }

  100% {
    left: 150%;
    transform: skewX(20deg);
    opacity: 1;
  }
}
</style>
